import React from "react";
import ReactPaginate from "react-paginate";

interface PaginationProps {
  pageCount: number;
  onPageChange: (selectedItem: { selected: number }) => void;
  currentPage: number;
  className?: string;
}

const Pagination: React.FC<PaginationProps> = ({
  pageCount,
  onPageChange,
  currentPage,
  className,
}) => {
  return (
    <div
      className={className ? className : `container flex justify-center mb-10`}
    >
      <ReactPaginate
        previousLabel={<span className="text-[#667085]">&lt;</span>}
        nextLabel={<span className="text-[#667085]">&gt;</span>}
        breakLabel="..."
        pageCount={pageCount}
        marginPagesDisplayed={1}
        pageRangeDisplayed={3}
        onPageChange={onPageChange}
        containerClassName="flex items-center justify-center gap-2 mt-8"
        pageClassName="w-10 h-10 flex items-center justify-center rounded-lg text-[#667085] border border-[#D0D5DD]"
        pageLinkClassName="w-full h-full flex items-center justify-center"
        activeClassName="!bg-primaryColor !text-white !border-primaryColor"
        previousClassName="w-10 h-10 flex items-center justify-center rounded-lg text-[#667085] border border-[#D0D5DD]"
        nextClassName="w-10 h-10 flex items-center justify-center rounded-lg text-[#667085] border border-[#D0D5DD]"
        disabledClassName="opacity-50 cursor-not-allowed"
        forcePage={currentPage - 1}
      />
    </div>
  );
};

export default Pagination;
